export enum EstadosOportunidad {
    EnGestion = '1',
    Ganada = '2',
    Perdida = '3'
    
}


export enum EstadosOportunidadNombre {
    EnGestion = 'En Gestión',
    Ganada = 'Ganada',
    Perdida = 'Perdida'   
}
